import { Fragment } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import Message from "../../components/message";
import { MessageSections } from "../../components/message/message";

export default function LimitAvoidModal({
  open,
  setOpen,
  callBack,
}: {
  open: boolean;
  setOpen: (arg: boolean) => void;
  callBack?: () => void;
}) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    setOpen(false);
    callBack?.();
  };

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Message
              messageKey={"order_limit_exceeded_sure_to_continue"}
              sectionId={MessageSections.ORDERS}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            <Message messageKey={"cancel"} sectionId={MessageSections.ORDERS} />
          </Button>
          <Button onClick={handleClick} autoFocus>
            <Message
              messageKey={"continue"}
              sectionId={MessageSections.ORDERS}
            />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
